import { render, staticRenderFns } from "./PermissionsEdit.vue?vue&type=template&id=c971a5de&"
import script from "./PermissionsEdit.vue?vue&type=script&lang=ts&"
export * from "./PermissionsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports